import { useActionErrorHandler } from './actionErrorHandler.hooks';

const ActionErrorHandler = () => {
  useActionErrorHandler();
  return <></>;
};

export default ActionErrorHandler;
